import React from "react";

export default function MonthButton({ monthIndex, monthDescription, selected, monthSelected, isCurrent }) {
    const className = [
        "month-btn",
        selected && "month-btn--selected",
        isCurrent && "month-btn--current"
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <button
            className={className}
            onClick={() => monthSelected(monthIndex)}
        >
            {monthDescription}
        </button>
    );
}
